import alt from './alt';

class actions {
    constructor() {
        this.generateActions(
                /* General Actions */
                // displaySumServer
            'storeSetState',
            'setBasicFields',
            'setEmpHistory',
            'setRemuneration',
            'setQualifications',
            'setAccomplishments',
            'setReferences',
            'setExtracurriculars',
            'setPersonalInfo',
            'setContactInfo'
        );
    }
}

export default alt.createActions(actions);